import styled from "styled-components";

export const Container = styled.div`
    background: #FFFFFF;    
    border-radius: 15px;    
`